import { combineReducers } from "redux";

import makeByIdReducerForTableKind, { FiltersById } from "./filtersById";
import { TableIdentifier } from "../../tableData/types";

export type State = {
  [TI in TableIdentifier as TI["kind"]]: FiltersById;
};

const filtersReducer = combineReducers<State>({
  administration: makeByIdReducerForTableKind("administration"),
  template: makeByIdReducerForTableKind("template"),
  templateVersion: makeByIdReducerForTableKind("templateVersion"),
});

export default filtersReducer;

export type Filters = State;
